
import { defineComponent, reactive } from 'vue'
import { getTitleInfo, getInstallModalIcon, tryno_info, product_id_info } from '@/services/config.service'

/** 软件未安装拦截对话框 */
export default defineComponent({
  name: 'InstallModal',
  props: {
    pid: {
      type: String,
      default: ''
    },
    tryno: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const viewModel = reactive({
      title: '',
      modalIcon: '',
      pid: props.pid as string,
      tryno: props.tryno
    })

    const { pid, tryno } = viewModel

    // 两个渠道的安装提示均沿用 win看图大师名称。
    viewModel.title =
      tryno === tryno_info.AiImageEditor || tryno === tryno_info.AiImageEditor6291
        ? getTitleInfo[product_id_info.aiImageEditor] : getTitleInfo[pid]
    viewModel.modalIcon = getInstallModalIcon[pid]

    /**
     * @description 成功处理
     */
    function onSuccess() {
      emit('onSuccess')
    }

    /**
     * @description 取消处理
     */
    function onCancel() {
      emit('onCancel')
    }

    return {
      viewModel,
      onCancel,
      onSuccess
    }
  }
})
